import { Box, Button, Card, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import logo1 from "../src/images/logo1.png";
import logo2 from "../src/images/logo2.png";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import hologramImage from "./images/hologram.png";
export default function CertificateCard() {
  const { id } = useParams();
  const [isExpired, setIsExpired] = useState(false);
  const [certificateData, setCertificateData] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const expiresAt = searchParams.get("expiresAt");
    if (expiresAt && Number(expiresAt) < Date.now()) {
      setIsExpired(true);
      setLoading(false);
      return;
    }
    if (id) {
      setLoading(true);
      axios
        .get(`https://devapi.myquals.com.au/get-certificate/${id}`)
        .then((response) => {
          setCertificateData(response.data);
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error fetching certificate:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id, location.search]);

  const formattedDate = certificateData?.refreshedAt
    ? moment(certificateData?.refreshedAt).format("DD MMM YYYY hh:mm A")
    : "";
  const formatedDob = certificateData?.contact?.dateOfBirth
    ? moment(certificateData?.contact?.dateOfBirth).format("DD MMM YYYY")
    : "";
  console.log(formatedDob);
  const issuedOn = certificateData?.issuedAt
    ? moment(certificateData?.issuedAt).format("DD MMM YYYY")
    : "";

  const isHologramView =
    certificateData?.user?.status === "verified" &&
    certificateData?.user?.info?.picture?.status === "verified";
  return (
    <>
      {isExpired ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="80vh"
          flexDirection="column"
        >
          <h2>QR Code Expired</h2>
          <p>Please generate a new certificate link.</p>
        </Box>
      ) : loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="80vh"
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <div className="cardBoxWrapper">
            {/* <div className="topIcon"> */}
            {/* <ArrowBackIcon /> */}
            {/* <MoreVertIcon /> */}
            {/* </div> */}
            <Card>
              <div className="refreshed">Refreshed {formattedDate}</div>
              <div className="logoImage">
                <img src={logo1} alt="logo1" height={30} width={60} />
                <img src={logo2} alt="logo2" height={50} width={50} />
              </div>
              <div className="imageBox">
                <img
                  src={`https://amplify-myquals-dev-09757-deployment.s3.ap-southeast-2.amazonaws.com/public/${
                    certificateData?.user?.info?.avatar?.key ||
                    certificateData?.user?.info?.picture?.key
                  }`}
                  alt="image-alt"
                />
              </div>
              <div className="heading1 mb-2 text-center mt-1">
                Statement of Attainment(SoA)
              </div>
              <div className="qrSection mb-2">
                <div className="leftBx">
                  <div className="heading2 mb-1">This is certify that</div>
                  <div className="heading4 mb-1">
                    {(
                      certificateData?.contact?.firstName ?? "N/A"
                    ).toUpperCase()}{" "}
                    {(
                      certificateData?.contact?.lastName ?? "N/A"
                    ).toUpperCase()}
                  </div>
                  <div className="heading2">has attained</div>
                </div>
                <div className="RightBx">
                  {/* <QRCodeSVG
                    value={`https://certificate.stg.myquals.com.au/get-certificate/${id}`}
                    size={100}
                  /> */}
                </div>
              </div>
              <div className="qrSection">
                <div className="leftBx">
                  <div className="contentBx">
                    <div className="heading2 mb-5">Unit of Competency Name</div>
                    <div className="heading1">
                      {certificateData?.unitOfCompetency?.name ?? "N/A"}
                    </div>
                  </div>
                  <div className="contentBx">
                    <div className="heading2 mb-5">Unit of Competency Code</div>
                    <div className="heading1">
                      {certificateData?.unitOfCompetency?.code ?? "N/A"}
                    </div>
                  </div>
                </div>
                <div className="RightBx">
                  <div className="contentBx">
                    <div className="heading2 mb-5">Date of Birth</div>
                    <div className="heading1">{formatedDob ?? "N/A"}</div>
                  </div>
                  <div className="contentBx">
                    <div className="heading2 mb-5">Outcome</div>
                    <div className="heading1">
                      {certificateData?.outcome ?? "N/A"}
                    </div>
                  </div>
                  <div className="contentBx">
                    <div className="heading2 mb-5">Issued On</div>
                    <div className="heading1">{issuedOn ?? "N/A"}</div>
                  </div>
                </div>
              </div>
              <div className="heading2 mt-2 mb-2">
                {certificateData?.rto?.info?.name ?? "N/A"}
              </div>
              <div className="heading2">
                <span>{certificateData?.rto?.info?.website ?? "N/A"}</span>
                <br />
                ABN:{certificateData?.rto?.info?.abn ?? "N/A"}
              </div>
              {isHologramView && (
                <div className="hologram">
                  <img
                    src={hologramImage}
                    alt="image-alt"
                    width="100%"
                    style={{ objectFit: "fill", borderRadius: "10px" }}
                  />
                </div>
              )}
            </Card>
          </div>
        </>
      )}
    </>
  );
}
